import * as actions from "../action.constants";

const initialState = {
  name: "default",
};

const storeTheme = (state, action) => {
  return {
    ...state,
    name: action.payload,
  };
};

const handlers = {
  [actions.STORE_THEME]: storeTheme,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
